"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("./api");
var _callbacks = _interopRequireDefault(require("../callbacks"));
var _config = _interopRequireDefault(require("../config"));
var _isError = _interopRequireDefault(require("lodash/isError"));
var _logger = _interopRequireDefault(require("./logger"));
var _peerManager = _interopRequireDefault(require("./peerManager"));
var _selectors = _interopRequireDefault(require("../selectors"));
var _streamManager = _interopRequireDefault(require("./streamManager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
var logger = new _logger.default('utils:ErrorManager');
var _sentryEnabled = /*#__PURE__*/new WeakMap();
var _env = /*#__PURE__*/new WeakMap();
var _lastErrorTriggered = /*#__PURE__*/new WeakMap();
class ErrorManager {
  constructor() {
    _classPrivateFieldInitSpec(this, _sentryEnabled, {
      writable: true,
      value: false
    });
    _classPrivateFieldInitSpec(this, _env, {
      writable: true,
      value: 'dev'
    });
    _classPrivateFieldInitSpec(this, _lastErrorTriggered, {
      writable: true,
      value: undefined
    });
    _defineProperty(this, "init", _ref => {
      var {
        env,
        sentry,
        sentryEnabled
      } = _ref;
      try {
        _classPrivateFieldSet(this, _sentryEnabled, sentryEnabled);
        _classPrivateFieldSet(this, _env, env);
        if (_classPrivateFieldGet(this, _sentryEnabled)) {
          _callbacks.default.get('sentryInit')({
            dsn: sentry.dsn,
            environment: _classPrivateFieldGet(this, _env),
            beforeSend: event => {
              var _event$user, _event$user2, _event$user3;
              var state = _callbacks.default.get('getState')();
              var now = Date.now();
              if (_config.default.isLocalEnv) {
                event.environment = 'development';
              }
              event.extra = event.extra || {};

              // clean private data
              // if (event.user?.email) {
              //    delete event.user.email;
              // }
              if ((_event$user = event.user) !== null && _event$user !== void 0 && _event$user.location) {
                delete event.user.location;
              }
              if ((_event$user2 = event.user) !== null && _event$user2 !== void 0 && _event$user2.biography) {
                delete event.user.biography;
              }
              if ((_event$user3 = event.user) !== null && _event$user3 !== void 0 && _event$user3.education) {
                delete event.user.education;
              }

              // display user feedback modal
              if (event.extra.dialog && _callbacks.default.isExist('sentryUserDialog') && (!_classPrivateFieldGet(this, _lastErrorTriggered) || now - _classPrivateFieldGet(this, _lastErrorTriggered) > 10000)) {
                // 10s
                _callbacks.default.get('sentryUserDialog')({
                  eventId: event.event_id
                });
                delete event.extra.dialog;
              }
              if (state) {
                var _room = _selectors.default.rooms._currentRoomSelector(state);
                var _feed = _selectors.default.feeds.selectedFeedSelector(state);
                var network = _selectors.default.network.all(state);
                if (!_classPrivateFieldGet(this, _lastErrorTriggered) || now - _classPrivateFieldGet(this, _lastErrorTriggered) > 1000) {
                  // 1s (flood security)
                  if (_room) {
                    var room = _selectors.default.rooms.currentRoomSelector(state);
                    event.extra.streamInfos = _streamManager.default.getAllStreamsInfo();
                    event.extra.peerInfos = _peerManager.default.getPeers();
                    event.extra.room = room;
                    event.extra.network = network;
                    event.tags._room = _room;
                  }
                  if (!_room && _feed) {
                    var feed = _selectors.default.feeds.feedLiteByIdSelector(_feed)(state);
                    event.extra.feed = feed;
                    event.tags._feed = _feed;
                  }
                }
              }
              _classPrivateFieldSet(this, _lastErrorTriggered, now);
              return event;
            }
          });
        }
      } catch (e) {
        logger.error(e);
      }
    });
    _defineProperty(this, "setTag", (key, value) => {
      try {
        _callbacks.default.get('sentrySetTag')(key, value);
      } catch (e) {
        logger.error(e);
      }
    });
    _defineProperty(this, "addBreadcrumb", (category, message, level) => {
      try {
        var _Callbacks$get;
        if (_classPrivateFieldGet(this, _sentryEnabled)) (_Callbacks$get = _callbacks.default.get('sentryAddBreadcrumb')) === null || _Callbacks$get === void 0 || _Callbacks$get(category, message, level);
      } catch (e) {
        logger.error(e);
      }
    });
    _defineProperty(this, "setExtra", (key, value) => {
      try {
        if (_classPrivateFieldGet(this, _sentryEnabled)) _callbacks.default.get('sentrySetExtra')(key, value);
      } catch (e) {
        logger.error(e);
      }
    });
    _defineProperty(this, "setUser", user => {
      try {
        if (_classPrivateFieldGet(this, _sentryEnabled)) _callbacks.default.get('sentrySetUser')(user);
      } catch (e) {
        logger.error(e);
      }
    });
    _defineProperty(this, "_capture", (err, tag, extra) => {
      try {
        if (_classPrivateFieldGet(this, _sentryEnabled)) {
          var sentryWithScope = _callbacks.default.get('sentryWithScope', false);
          if (!extra && !tag || !sentryWithScope) {
            if ((0, _isError.default)(err)) {
              return _callbacks.default.get('sentryCaptureException')(err);
            } else if ((0, _api.isAxiosError)(err)) {
              return _callbacks.default.get('sentryCaptureMessage')("".concat(tag, ": ").concat(err === null || err === void 0 ? void 0 : err.statusText));
            } else {
              return _callbacks.default.get('sentryCaptureMessage')("".concat(tag, ": ").concat(err));
            }
          }
          return sentryWithScope(scope => {
            if (tag) {
              scope.setTag('tag', tag);
            }
            if (extra) {
              if (typeof extra === 'string') {
                scope.setExtra('extra', extra);
              } else if (typeof extra === 'object') {
                Object.keys(extra).map(key => scope.setExtra(key, extra[key]));
              }
            }
            if ((0, _api.isAxiosError)(err)) {
              var _err$response, _err$response2, _err$response3;
              var {
                status,
                message,
                code
              } = err;
              var networkExtra = {
                status,
                message,
                code
              };
              scope.setTag('code', err.code);
              if (err.response) {
                var {
                  headers,
                  status: _status,
                  data,
                  statusText
                } = err.response;
                networkExtra = _objectSpread(_objectSpread({}, networkExtra), {}, {
                  headers: JSON.stringify(headers),
                  status: _status,
                  statusText,
                  data
                });
                scope.setTag('responseCode', data === null || data === void 0 ? void 0 : data.code);
                scope.setTag('responseStatus', _status);
                scope.setTag('cf-ray', headers === null || headers === void 0 ? void 0 : headers['cf-ray']);
              }
              if (err.request) {
                var {
                  timeout
                } = err.request;
                networkExtra = _objectSpread(_objectSpread({}, networkExtra), {}, {
                  timeout
                });
              }
              if (err.config) {
                var {
                  url,
                  method
                } = err.config;
                networkExtra = _objectSpread(_objectSpread({}, networkExtra), {}, {
                  url,
                  method
                });
              }
              scope.setExtra('axios', networkExtra);
              return _callbacks.default.get('sentryCaptureException')(new Error("".concat(((_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.message) || ((_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.statusText) || 'Request failed', " (").concat(((_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.status) || err.code || 'Probably CORS error', ")")));
            } else if ((0, _isError.default)(err)) {
              return _callbacks.default.get('sentryCaptureException')(err);
            } else {
              return _callbacks.default.get('sentryCaptureMessage')("".concat(tag, ": ").concat(err));
            }
          });
        }
      } catch (e) {
        logger.error(e);
      }
    });
    _defineProperty(this, "captureException", (err, tag, extra) => {
      logger.error('captureException', err, tag, extra);
      this._capture(err, tag, extra);
    });
    _defineProperty(this, "captureMessage", (msg, title, extra) => {
      logger.log('captureMessage', msg, title, extra);
      this._capture(msg, title, extra);
    });
  }
}
var _default = exports.default = new ErrorManager();
module.exports = exports.default;